module.exports = __webpack_public_path__ + "static/media/panellogo.1d3d9baf.png";